import { Component, ElementRef, EventEmitter, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { OpsService } from 'src/app/services/ops/ops.service';
import { EnvironmentEnum } from 'src/app/utils/interfaces/new/CreateOps';
import { TypeEnum } from 'src/app/utils/interfaces/new/Instance';
import { environment } from 'src/environments/environment';
import { DocumentReturn } from '../../user/multiprofessional-protocol/edit-protocol/modal-select-file/modal-select-file.component';

@Component({
  selector: 'app-modale-ops-cabinet-deployment',
  templateUrl: './modale-ops-cabinet-deployment.component.html',
  styleUrls: ['./modale-ops-cabinet-deployment.component.scss',
    '../../../fragments/modal/modal.fragment.scss'
  ]
})
export class ModaleOpsCabinetDeploymentComponent implements OnInit {

  @ViewChild('modalBody') public modalBody: ElementRef;
  @ViewChild('outsideModal') public outsideModal: ElementRef;

  public closeEmitter = new EventEmitter();
  public formGroup: FormGroup;
  public cabinetId: string;
  instancesValues: string[];
  loading: boolean;

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }

    if (!this.modalBody.nativeElement.contains(event.target) && this.outsideModal.nativeElement.contains(event.target)) {
      this.closeModal();
    }
  }

  constructor(
    private _formBuilder: FormBuilder,
    private _opsService: OpsService
  ) { }

  async ngOnInit(): Promise<void> {
    this.formGroup = this._formBuilder.group({
      dbMedical: ["", Validators.required],
      dbUser: ["", Validators.required],
      dbLog: ["", Validators.required],
    });
    this.loading = true;
    this.instancesValues = await this._opsService.getDbInstanceList()
    this.loading = false;
  }

  public async validForm(): Promise<void> {
    await this._opsService.deployCabinet({
      cabinetId: this.cabinetId,
      environment: environment.env as EnvironmentEnum,
      instances: [
        {
          instance: this.formGroup.get("dbMedical").value,
          type: TypeEnum.Medical
        },
        {
          instance: this.formGroup.get("dbUser").value,
          type: TypeEnum.User
        },
        {
          instance: this.formGroup.get("dbLog").value,
          type: TypeEnum.Logs
        }
      ]
    });

    // TODO Mettre les logs

    this.closeModal();
  }

  public closeModal(): void {
    this.closeEmitter.emit();
  }

}
